import React from "react";
import styled from "styled-components";
import {SearchResultIcon} from "./SearchResultIcon";
import IdeaCounts from "../../../idea/IdeaCounts";
import {SentimentValue} from "../../../stocks/sentiment/Sentiment";
import {CompanyName} from "./Names";

const Container = styled.div`
    display: flex;
    align-items: center;
`;

const Bloomberg = styled.div`
    font-weight: bold;
    margin-right: 5px;
    min-width: 115px;
`;

export const OrganisationSuggestion = ({data, isHighlighted}) => {
    const {bloomberg, companyName, sentiment, openIdeas} = data;
    return <Container>
        <SearchResultIcon type="ORGANISATION" isHighlighted={isHighlighted}/>
        <Bloomberg className="t-bloomberg">{bloomberg}</Bloomberg>
        <CompanyName isHighlighted={isHighlighted} width={200} marginRight={10}>
            {companyName}
        </CompanyName>
        <IdeaCounts inverted={isHighlighted} style={{marginRight: 2}} openIdeas={openIdeas}/>
        {sentiment ? <SentimentValue sentiment={sentiment}/> : null}
    </Container>;
};